import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=6d7caebd&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=ts&"
export * from "./Privacy.vue?vue&type=script&lang=ts&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=6d7caebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7caebd",
  null
  
)

export default component.exports